var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3h-1.5v-.75a.75.75 0 10-1.5 0V3h-4.5v-.75a.75.75 0 00-1.5 0V3h-1.5A2.25 2.25 0 002 5.25v9a2.25 2.25 0 002.25 2.25h10.5A2.25 2.25 0 0017 14.25v-9A2.25 2.25 0 0014.75 3zm.75 11.25a.75.75 0 01-.75.75H4.25a.75.75 0 01-.75-.75V9h12v5.25zm0-6.75h-12V5.25a.75.75 0 01.75-.75h1.5v.75a.75.75 0 001.5 0V4.5h4.5v.75a.75.75 0 101.5 0V4.5h1.5a.75.75 0 01.75.75V7.5z",
    fill: "#fff"
  })));
}
export default SvgCalender;